<template>
  <div class="project-hr">
    <h3 class="project-hr__title">Assigned HR</h3>

    <v-form class="project-hr__content">
      <v-row>
        <v-col cols="10 ">
          <v-select
            v-model="currentAssignedHr"
            class="project-hr__select form-field"
            :items="projectData.available_hrs"
            :item-text="getHRName"
            item-value="id"
            dense
            item-color="blue"
            label="HR"
            placeholder="Choose HR"
          />
        </v-col>

        <v-col cols="2" class="project-hr__btn">
          <v-btn
            class="fw-400"
            color="blue"
            medium
            dark
            :loading="isSubmitProcessing"
            @click="saveChanges"
          >
            SAVE CHANGE
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      currentAssignedHr: '',
    };
  },

  computed: {
    ...mapState('hrProject', [
      'projectData',
      'isSubmitProcessing',
    ]),
  },

  watch: {
    projectData: {
      handler() {
        this.currentAssignedHr = { ...this.projectData.assigned_hr };
      },
      deep: true,
    },
  },

  methods: {
    getHRName(item) {
      return `${item.first_name} ${item.last_name}`;
    },

    saveChanges() {
      this.$emit('save', this.currentAssignedHr);
    },
  },
};
</script>

<style lang="scss" scoped>
.project-hr {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__title {
    color: $color--primary;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__dates {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0;
  }
  &__col {
    padding-top: 0;
  }
  &__btn {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }
}
</style>
